import { useAppQuery } from "~/hooks/useAppQuery"
import { getPlans } from "../server/plans.functions"

export const plansQueryKey = ["home", "profile", "plans"] satisfies readonly ["home", "profile", "plans"]

export function usePlans() {
  return useAppQuery({
    queryKey: plansQueryKey,
    queryFn: () => getPlans(),
    errorMessage: "Не удалось загрузить тарифы",
  })
}
